import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { metaStyle as meta } from '../utils/shopHealth';
import FeedUploadForm from '../components/FeedUploadForm';

// Upload a feed file — the escape hatch for a shop the network cannot supply
// directly.
//
// It kept a permanent place on `/feeds` because it is the escape hatch and
// `feed-listing` requires navigating to Feeds to show it. That was right about
// the requirement and wrong about the place: at the live account's 43 shops it
// sat 18.1 phone screens down, so the thing kept visible on purpose was the
// thing nobody could reach. It is now one named link from the top of the hub,
// at the same depth whether the publisher has no shops or a hundred.

const UploadFeedPage: React.FC = () => {
  // IT DOES NOT NAVIGATE ON SUCCESS, AND THAT IS DELIBERATE. The result panel is
  // rendered by the form itself and carries the whole account of what happened —
  // rows read, imported, rejected and warned, grouped issues with sample row
  // numbers, and the explanation when a mostly-broken file was refused and
  // nothing changed. Navigating away the moment the upload returns destroys
  // exactly the thing the publisher needs to read, and a refused upload would
  // look identical to a successful one. So the page stays and offers the way
  // back; the hub re-reads its list on mount, so nothing is stale when they take
  // it.
  const [uploaded, setUploaded] = useState(false);

  return (
    <>
      <p style={{ ...meta, marginBottom: '0.75rem' }}>
        <Link to="/feeds" data-testid="back-to-feeds">← Your shops</Link>
      </p>

      <section className="feeds-section" data-testid="upload-feed-page">
        <h2>Upload a feed file</h2>
        <p className="no-data">
          For a shop your network cannot supply directly. These products and affiliate links join
          the shops on your Feeds page.
        </p>

        {/* A FILE DOES NOT REFRESH, AND A URL DOES. Said here because this is the
            one moment a publisher is choosing between the two, and the better
            path was the more hidden one for as long as both were buried. */}
        <p style={meta}>
          An uploaded file is a snapshot: it will not refresh on its own, so its prices drift as
          the shop changes them. If your shop publishes a feed URL,{' '}
          <Link to="/feeds/connect">connect it by URL</Link> instead and we will keep it in step.
        </p>

        <FeedUploadForm onUploadSuccess={() => setUploaded(true)} />

        {uploaded && (
          <p style={{ marginTop: '1rem' }} data-testid="upload-done">
            <Link to="/feeds">← Back to your shops</Link>
          </p>
        )}
      </section>
    </>
  );
};

export default UploadFeedPage;
